import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { 
  Target, TrendingUp, BarChart3, LineChart, 
  Activity, Briefcase, PieChart, Zap
} from "lucide-react";

const AnalysisSections = ({ currentPage = "dashboard" }) => {
  const sections = [
    {
      id: "scanner",
      title: "5:1 R/R Scanner",
      description: "High risk/reward opportunities",
      icon: Target,
      href: "/scanner",
      color: "from-green-500 to-emerald-600",
      badge: "Scanner"
    },
    {
      id: "portfolio",
      title: "Portfolio Designer",
      description: "AI-powered 40%+ returns",
      icon: PieChart,
      href: "/portfolio",
      color: "from-purple-500 to-indigo-600",
      badge: "AI"
    },
    {
      id: "options-generator",
      title: "Options Generator",
      description: "5%+ daily returns",
      icon: Zap,
      href: "/options-generator",
      color: "from-orange-500 to-red-600",
      badge: "High-Freq"
    },
    {
      id: "dashboard",
      title: "Stock Analysis",
      description: "Deep dive into any ticker",
      icon: BarChart3,
      href: "/",
      color: "from-blue-500 to-blue-600",
      badge: "Analysis"
    }
  ];

  // Filter out current page
  const filteredSections = sections.filter(s => s.id !== currentPage);

  return (
    <Card className="border-slate-200 bg-white/80 backdrop-blur-sm shadow-lg">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Activity className="w-5 h-5 text-indigo-600" />
          Analysis Sections
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filteredSections.map((section) => {
            const Icon = section.icon;
            return (
              <a
                key={section.id}
                href={section.href}
                className="group relative overflow-hidden rounded-xl border border-slate-200 bg-white p-4 hover:shadow-lg transition-all duration-300 hover:border-indigo-300" target="_blank" rel="noopener noreferrer">
                {/* Gradient Background on Hover */}
                <div className={`absolute inset-0 bg-gradient-to-br ${section.color} opacity-0 group-hover:opacity-5 transition-opacity`} />
                
                <div className="relative flex items-start gap-3">
                  <div className={`p-2 rounded-lg bg-gradient-to-br ${section.color} text-white`}>
                    <Icon className="w-5 h-5" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <h3 className="font-semibold text-slate-800 group-hover:text-indigo-600 transition-colors">
                        {section.title}
                      </h3>
                      <Badge variant="outline" className="text-[10px] px-1.5 py-0">
                        {section.badge}
                      </Badge>
                    </div>
                    <p className="text-xs text-slate-500">{section.description}</p>
                  </div>
                  <Zap className="w-4 h-4 text-slate-300 group-hover:text-yellow-500 transition-colors" />
                </div>
              </a>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default AnalysisSections;
